/**
 * 공개 사이트 공통 틀 문구 — ko/landingSite.ts 와 같은 키(정본은 ko).
 */
const landingSite = {
  "skipToContent": "本文へ移動",
  "homeLabel": "DroneSquare ホーム",
  "nav": {
    "label": "メインメニュー",
    "mobileLabel": "モバイルメニュー",
    "openMenu": "メニューを開く",
    "closeMenu": "メニューを閉じる",
    "services": "サービス",
    "plans": "料金プラン",
    "inquiry": "1:1 お問い合わせ",
    "news": "報道資料",
    "manual": "マニュアル",
    "releases": "アップデート情報"
  },
  "servicePanel": {
    "platform": {
      "title": "プラットフォーム",
      "description": "2D・3D・4D 点検、断面・土工、現場記録と管制"
    },
    "survey": {
      "title": "ドローン測量と空間データ加工",
      "description": "飛行承認からオルソ画像・DSM・3Dモデル・数値地形図まで"
    },
    "more": "詳しく見る →"
  },
  "account": {
    "login": "ログイン",
    "start": "始める",
    "logout": "ログアウト",
    "flightHub": "ドローン管制システム接続",
    "flightHubFailed": "ドローン管制システムに接続できません。しばらくしてからもう一度お試しください。"
  },
  "share": {
    "label": "共有",
    "menuLabel": "共有する",
    "copied": "リンクをコピー済み",
    "failed": "リンクをコピーできませんでした。"
  },
  "footer": {
    "menuLabel": "フッターメニュー",
    "company": "会社紹介",
    "terms": "利用規約",
    "privacy": "個人情報処理方針",
    "contact": "提携/利用お問い合わせ",
    "companyName": "(株)アルティビオン",
    "businessNumber": "事業者登録番号: 146-81-03772",
    "address": "〒05836 ソウル特別市松坡区文井洞 640 KDUタワー 7階 707号",
    "telLabel": "代表電話",
    "hours": "営業時間 : 10:00 - 18:30 · 昼休み : 12:00 - 13:30",
    "closed": "土曜日・日曜日・祝日休業",
    "copyright": "Copyright © ALTIVION Inc. All rights reserved."
  },
  "contact": {
    "telLabel": "代表電話",
    "hoursLines": ["営業時間 : 10:00 - 18:30", "昼休み : 12:00 - 13:30", "土曜日・日曜日・祝日休業"],
    "inquiry": "お問い合わせ"
  },
  "sectionIndex": "セクション移動",
  "sectionIndexItem": "{{n}}番目のセクション",
  "flow": {
    "label": "ドローンマッピングの進行手順",
    "steps": [
      {
        "title": "飛行承認",
        "text": "飛行区域と高度を確認し、関連法規に従って飛行と撮影の承認を受けます。",
        "alt": "航空区域図の上で飛行する空域の境界を指でたどって確認する様子"
      },
      {
        "title": "撮影計画 · 自動飛行",
        "text": "現場の範囲と必要な解像度に合わせて飛行経路と写真の重複率を決め、自動飛行で撮影します。",
        "alt": "青空を飛ぶ撮影用ドローン"
      },
      {
        "title": "GCP測量",
        "text": "地上基準点（GCP）を設置して測量し、成果物の位置精度を高めます。",
        "alt": "三脚に立てたGNSS受信機と地面のGCP標識、その横でタブレットに座標を記録する測量者"
      },
      {
        "title": "画像 · 映像の取得",
        "text": "計画した経路に沿って飛行し、現場の写真と映像を撮影します。",
        "alt": "ドローンで撮影した高速道路のインターチェンジ"
      },
      {
        "title": "オルソ画像 · DSM · 3Dモデル処理",
        "text": "撮影した写真を整合し、点群とオルソ画像、DSM、3Dモデルを作成します。",
        "alt": "ドローン写真で作った土工現場の3Dモデル。削られた法面と平坦地が立体的に見える。"
      },
      {
        "title": "プラットフォーム",
        "text": "オルソ画像・3Dモデルを DroneSquare プラットフォームに載せ、地図上で確認・計測します。",
        "alt": "DroneSquare アプリマーク"
      }
    ]
  },
  "education": {
    "eyebrow": "教育 · コンサルティング · 法規 · 安全",
    "title": "ドローン運用からソフトウェア活用まで、<br/>現場に合わせてサポートします",
    "photoAlt": "DRONE SQUAREのベストを着たコンサルタントが等高線図面の現場を指し示し、ノートPCとタブレットのドローン地図を見比べる様子",
    "cards": [
      {
        "kicker": "教育",
        "title": "現場に合わせた教育",
        "text": "ドローン運用からソフトウェア活用まで、現場に合わせた教育で業務への適用力を高めます。",
        "alt": "ヘルメットとベストを着た受講者が現場の机を囲み、ノートPCの地図と図面資料を見ながら教育を受ける様子"
      },
      {
        "kicker": "コンサルティング",
        "title": "最適なドローン活用方法",
        "text": "プロジェクトの特性に合った最適なドローン活用方法と実行戦略を提供します。",
        "alt": "DRONE SQUAREのベストを着たコンサルタントが等高線図面の現場を指し示し、ノートPCとタブレットのドローン地図を見比べる様子"
      },
      {
        "kicker": "法規",
        "title": "飛行・測量関連法規の遵守",
        "text": "ドローン飛行と測量に関する法規を遵守し、安全で適法なサービスを提供します。",
        "alt": "クリップボードの書類に記入する作業員の手"
      },
      {
        "kicker": "安全教育",
        "title": "作業員の安全のための指針",
        "text": "ドローン活用時の作業員の安全のための体系的な教育と指針を提供します。",
        "alt": "ヘルメット、手袋、イヤーマフ、保護メガネ"
      }
    ]
  },
  "partners": {
    "title": "協力会社",
    "logos": [
      "スソンエンジニアリング",
      "泰栄建設",
      "現代建設",
      "SKエコエンジニアリング",
      "ウデE&P",
      "K water Tech",
      "豊林産業",
      "活林建設",
      "韓国漁村漁港公団",
      "HJ重工業",
      "Liberaware"
    ]
  },
  "rows": {
    "pfLayers": {
      "kicker": "断面レイヤー",
      "title": "撮影日とレイヤーを選んで重ねる",
      "text": "断面グラフのレイヤー一覧で、撮影日ごとの地盤線、DXF計画線、BIMをオン・オフしながら一つのグラフで比較します。",
      "alt": "実際の断面グラフとレイヤー一覧。3つの撮影日のメッシュレイヤーを選んでオンにする様子。"
    },
    "earthwork": {
      "kicker": "線形・区域ベースの土工量",
      "title": "区域を描くだけで撮影日ごとに土工量を算出",
      "text": "切土と盛土の量を撮影日ごとに自動で求めます。計画数量に対する進捗と残りを一つの表で確認し、CSVでダウンロードできます。",
      "alt": "実際の土工画面の土工集計表。切土・盛土を土質別に分け、計画数量、残土工量、日別累計、撮影日ごとの進捗量を示す。"
    },
    "measure": {
      "kicker": "2D/3D計測",
      "title": "長さ・面積・体積を画面ですぐに",
      "text": "地点をクリックすると座標と高さが、複数の点をつなぐと区間ごとの長さが表示されます。領域を描けば法面まで反映した面積と体積もすぐに分かります。",
      "alt": "実際の3D画面で平坦地の面積を計測した様子（計測部分を拡大）。中央のチップに立体面積1330.57 m²と平面面積1328.98 m²、各辺の長さが表示される。"
    },
    "issue": {
      "kicker": "課題",
      "title": "課題をその場所に残し、撮影日ごとに確認",
      "text": "点・線・領域で課題を示し、内容と状態を記録します。撮影日を切り替えながら同じ課題の場所の変化を確認します。",
      "alt": "実際の2D画面で選択した法面の土砂流出の課題領域と、左側の課題情報パネルの撮影日・課題の強度推移・課題情報が見える。"
    },
    "geolog": {
      "kicker": "写真 · 動画",
      "title": "撮影した場所に集まる現場の写真と動画",
      "text": "現場で撮った写真や動画をアップロードすると位置ごとにマーカーとして集まり、マーカーをクリックするとその場ですぐに開けます。",
      "alt": "実際の2D画面の左側の写真・動画パネルと、地図上のマーカーをクリックして開いた動画記録カード。"
    },
    "pano": {
      "kicker": "360°",
      "title": "360°写真で現場の中まで",
      "text": "360°写真をアップロードすると、撮影した場所で見回すように現場の中を確認できます。",
      "alt": "実際のアプリの360°表示画面全体。工事中の建物内部と位置のミニマップ、写真送り（1/3）・2D切り替えボタンが見える。"
    },
    "equip": {
      "kicker": "機材動線シミュレーション",
      "title": "機材の動線と作業半径の重なりを事前に",
      "text": "作業状況3Dで機材を配置して動線を描くと、再生中に機材が動き、作業半径が重なる場所に危険表示が現れます。",
      "alt": "実際の作業状況3D画面で、ショベル2台が反対方向の動線ですれ違い、作業半径が重なった瞬間に危険領域が表示され、ダンプトラックがその間を北へ横切る。"
    }
  },
  "scenes": {
    "view": {
      "eyebrow": "2D · 3D · 4D",
      "title": "平面から立体へ、そして時間まで",
      "lead": "ドローンで撮影した現場を2Dオルソ画像と3Dモデルで確認し、<brd/>画面を最大4つに分けて撮影日ごとに比較しましょう。",
      "stepsLabel": "表示ステップ",
      "steps": [
        {
          "k": "2Dオルソ画像",
          "d": "ドローン写真で作った高解像度の地図"
        },
        {
          "k": "3Dモデル",
          "d": "同じ現場を3D画面に切り替え"
        },
        {
          "k": "4D時系列",
          "d": "画面を4つに分けて撮影日ごとに比較"
        }
      ],
      "viewLabel": "実際のドローンデータで作った土工現場。オルソ画像の地図を3D画面に切り替えた後、画面を4つに分けて2025年3月から2026年3月までの4つの撮影日の工事進捗を比較する。"
    },
    "bridge": {
      "eyebrowLanding": "測量 · 土工 · 用地",
      "eyebrowPlatform": "測量 · 断面 · 土工",
      "title": "線を1本引けば、地面と構造物の中まで",
      "lead": "3D画面に線を引くと、地形とBIMを一緒に切った断面が描かれます。<brd/>時系列で重ねて見て、TXT・CSV・DXFですぐに書き出しましょう。",
      "stepsLabel": "断面ステップ",
      "steps": [
        {
          "k": "縦断面",
          "d": "橋梁の軸に沿って線を引くとすぐ断面に"
        },
        {
          "k": "横断面",
          "d": "橋脚の位置を横切って引いた断面"
        },
        {
          "k": "時系列の重ね表示",
          "d": "撮影日ごとの地盤線にDXF・BIMレイヤーまで一つのグラフに"
        },
        {
          "k": "書き出し",
          "d": "点間隔を決めてTXT・CSV・DXFに"
        }
      ],
      "viewLabel": "実際の橋梁工事現場の3DモデルにBIM（桁・床版・橋脚・橋台）を重ねた画面。橋梁の軸に沿って線を引くと下の縦断面グラフに地盤線と橋梁断面が描かれ、橋脚位置の横断面、2つの撮影日の地盤線を重ねた時系列比較、点間隔データの書き出し（TXT・CSV・DXF）まで続く。",
      "lon": "縦断面",
      "crs": "横断面",
      "capture": "画像キャプチャ",
      "extract": "点間隔の抽出",
      "popTitle": "データ抽出",
      "popSpacing": "点間隔",
      "popUnit": "m",
      "dateNow": "2026.03.20",
      "datePast": "2025.11.21",
      "bim": "橋梁BIM",
      "distance": "距離 (m)",
      "height": "高さ (m)"
    },
    "layers": {
      "eyebrow": "レイヤーの重ね合わせ",
      "title": "すべてのデータを一度に",
      "lead": "設計図面と地籍、現場記録を一つの3D画面に重ねて見て、<brd/>作業状況3Dで人員と機材の危険まで事前に確認しましょう。",
      "stepsLabel": "レイヤーステップ",
      "steps": [
        {
          "k": "DXF · 地籍GIS",
          "d": "計画路線と筆界を3D現場の上に"
        },
        {
          "k": "BIM",
          "d": "構造物BIMを現場の地形と一緒に"
        },
        {
          "k": "Point Cloud",
          "d": "現場を点データのまま"
        },
        {
          "k": "ベクター",
          "d": "地中の管路をボリューム線で"
        },
        {
          "k": "クリッピング",
          "d": "箱で切って地中の断面まで"
        },
        {
          "k": "現場記録",
          "d": "課題・写真・動画・360°を位置ごとに"
        },
        {
          "k": "人員 · 機材シミュレーション",
          "d": "作業半径と動線の危険を事前に"
        }
      ],
      "viewLabel": "実際のドローンデータで作った土工現場の3D画面。設計路線と地籍境界、擁壁BIM、点群、地中の管路（ボリューム線）、ボックスクリッピング断面、課題と現場写真の位置を順に重ねた後、作業状況3D画面でショベルとダンプトラックが描いておいた動線に沿って動き、2台のショベルの作業半径が重なった瞬間に危険領域が表示される。",
      "wallBim": "擁壁BIM",
      "waterPipe": "上水管",
      "stormPipe": "雨水管",
      "issues": [
        "法面の土砂流出",
        "排水路の詰まり",
        "盛土部の亀裂"
      ]
    },
    "dates": {
      "main": "2026年03月20日",
      "panes": [
        "2025年03月14日",
        "2025年07月18日",
        "2025年11月21日",
        "2026年03月20日"
      ]
    }
  }
} as const;

export default landingSite;
